module.exports = __webpack_public_path__ + "img/打样ico.56535556.png";